// SpecialtiesDropdown.js
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/specialties.css";
import { useDispatch, useSelector } from "react-redux";
import { getSpecialitieswithSub } from "../features/Specialities/specialitiesApi";

const SpecialtiesDropdown = ({
  isOpen,
  setIsOpen,
  mobileView = false,
  closeSidebar,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { getAllSpecialities } = useSelector((state) => state.specialities);

  useEffect(() => {
    dispatch(getSpecialitieswithSub());
  }, [dispatch]);

  const handleMouseLeave = () => {
    if (!mobileView) {
      setIsOpen(false);
    }
  };

  const handleLearnMore = (slug) => {
    if (slug) {
      navigate(`/specialty/${slug}`);
      setIsOpen(false);
      if (closeSidebar) {
        closeSidebar();
      }
    }
  };

  const groupIntoColumns = (items, columns = mobileView ? 1 : 4) => {
    const result = Array.from({ length: columns }, () => []);
    items.forEach((item, i) => result[i % columns].push(item));
    return result;
  };

  const groupedSpecialties = groupIntoColumns(getAllSpecialities);

  return (
    <>
      {isOpen && !mobileView && (
        <div
          className="fixed inset-0 z-[998]"
          onClick={() => setIsOpen(false)}
        ></div>
      )}
      <div
        className={`${
          mobileView ? "relative" : "fixed left-0 right-0 container mx-auto"
        } bg-white ${mobileView ? "" : "z-[999]"} ${
          isOpen ? "opacity-100 visible" : "opacity-0 invisible"
        } ${!mobileView && "lg:top-[145px] border-t border-gray-100"}`}
        onMouseLeave={handleMouseLeave}
      >
        <div
          className={`${
            mobileView ? "" : "container mx-auto px-4 lg:px-8 py-4"
          }`}
        >
          <div
            className={`${
              mobileView
                ? "max-h-[60vh] overflow-y-auto px-2 custom-scrollbar" // CHANGED: Added max-height and scroll
                : "max-h-[calc(100vh-180px)] overflow-y-auto px-2 custom-scrollbar"
            }`}
          >
            <div className="relative flex justify-between">
              <div className="columns-1 xl:columns-4 w-full">
                {groupedSpecialties.map((column, colIndex) => (
                  <div
                    key={colIndex}
                    className="w-full" // Changed px-4 to px-2
                  >
                    {column.map((specialty) => (
                      <div key={specialty._id} className="mb-3">
                        {" "}
                        {/* Changed mb-5 to mb-3 */}
                        <p
                          to={`/specialties/${
                            specialty.slug ||
                            specialty.title.toLowerCase().replace(/\s+/g, "-")
                          }`}
                          className="text-primary font-semibold mb-2 hover:text-secondary transition-colors duration-200 flex items-center cursor-default group border-b border-gray-200 pb-1"
                          onClick={() => {
                            if (mobileView && closeSidebar) {
                              closeSidebar();
                            }
                          }}
                        >
                          <span className="specialty-dot bg-red-500 mr-2"></span>
                          {specialty.title}
                        </p>
                        {specialty.subSpecialties?.length > 0 && (
                          <ul className="ml-6 mt-1">
                            {specialty.subSpecialties.map((sub) => (
                              <li key={sub._id}>
                                <div
                                  onClick={() => handleLearnMore(sub.slug)}
                                  className="text-gray-600 hover:text-primary text-sm flex items-center py-1 cursor-pointer"
                                >
                                  <span className="text-red-500 mr-2">→</span>
                                  {sub.title}
                                </div>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SpecialtiesDropdown;
